/*   Copyright 2017 Agneta Network Applications, LLC.
 *
 *   Source file: theme/source/moment.extend.js
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

/*global moment*/

moment.fn.hourOfYear = function(value) {

  if (value) {
    var dayOfYear = Math.ceil(value / 24);
    var hour = value % 24;
    this.dayOfYear(dayOfYear);
    this.hour(hour);
    return this;
  }

  return ((this.dayOfYear() - 1) * 24) + this.hour();

};
